import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PriceCheckOutlinedIcon from "@mui/icons-material/PriceCheckOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import ZephyrIconWhite from "@/Images/Icons/Zephyr_Icon_White.png";
import ScriptsToProcessTab from "./processing/ScriptsToProcessTab";
import PricingReviewTab from "./processing/PricingReviewTab";
import ComcareTab from "./processing/ComcareTab";
import BatchesTab from "./processing/BatchesTab";

const Z_PURPLE = "#38184f";
const Z_BLUE = "#2baede";

const TABS = [
  { label: "Scripts to Process", Icon: DescriptionOutlinedIcon },
  { label: "Pricing Review",     Icon: PriceCheckOutlinedIcon },
  { label: "ComCare & VIC",      Icon: AssignmentOutlinedIcon },
  { label: "Batches",            Icon: ChecklistOutlinedIcon },
];

export default function ZephyrProcessingPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>

      {/* Header */}
      <Box sx={{
        background: `linear-gradient(135deg, ${Z_PURPLE} 0%, #1e0a36 100%)`,
        px: 3, py: 2,
        display: "flex", alignItems: "center", gap: 2,
        flexShrink: 0,
      }}>
        <img src={ZephyrIconWhite} alt="" style={{ height: 28, opacity: 0.9 }} />
        <Typography fontWeight={700} fontSize="1.1rem" color="#fff">Script Processing</Typography>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: `2px solid ${Z_PURPLE}20`, background: "#fff", flexShrink: 0 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          TabIndicatorProps={{ style: { backgroundColor: Z_BLUE, height: 3 } }}
          sx={{ px: 2 }}
        >
          {TABS.map(({ label, Icon }, i) => (
            <Tab
              key={i}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                  <Icon sx={{ fontSize: 18 }} />
                  <span>{label}</span>
                </Box>
              }
              sx={{
                fontWeight: 600,
                fontSize: "0.82rem",
                color: activeTab === i ? Z_PURPLE : "#64748b",
                textTransform: "none",
                minHeight: 48,
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box sx={{ flex: 1, overflow: "auto", p: 3, background: "#f8fafc" }}>
        {activeTab === 0 && <ScriptsToProcessTab onProcessingComplete={(hasReview) => { if (hasReview) setActiveTab(1); }} />}
        {activeTab === 1 && <PricingReviewTab />}
        {activeTab === 2 && <ComcareTab />}
        {activeTab === 3 && <BatchesTab />}
      </Box>
    </Box>
  );
}
